<template>
  <van-pull-refresh v-model="refreshing" class="faq-list-container" @refresh="handleRefresh">
    <van-tabs :active="active" @change="onChangeCategory">
      <van-tab
        v-for="(category,categoryIndex) in issueCategoryList"
        :key="categoryIndex"
        :title="category"
      >
        <van-collapse :value="activeName" accordion @change="onChange">
          <van-collapse-item
            v-for="(issue,issueIndex) in issueList"
            :key="issue.id"
            :name="issueIndex"
          >
            <template slot="title">
              <span>{{ issue.question }}</span>
            </template>
            <ArticleContent :content="issue.answer" />
          </van-collapse-item>
        </van-collapse>
      </van-tab>
    </van-tabs>
  </van-pull-refresh>
</template>

<script type="text/javascript">
import ArticleContent from '@/views/article/components/ArticleContent'
import { getIssueCategoryList, getIssueList } from '@/api/other'
import { Toast } from 'vant'

export default {
  components: {
    ArticleContent
  },
  data() {
    return {
      activeName: null,
      active: 0,
      issueCategoryList: [], // 分类列表
      issueList: [],
      refreshing: false,
      currentCategory: ''
    }
  },
  mounted() {
    this.loadIssueCategoryList()
  },
  methods: {
    loadIssueCategoryList() {
      getIssueCategoryList().then(response => {
        this.issueCategoryList = response.data
        if (this.issueCategoryList.length > this.active) {
          this.currentCategory = this.issueCategoryList[this.active]
        }
        this.loadIssueList()
      })
    },
    loadIssueList() {
      const category = this.currentCategory
      return new Promise((resolve, reject) => {
        getIssueList({ category: category })
          .then(({ data }) => {
            this.issueList = data
            resolve(data)
          })
          .catch(error => {
            // 设置列表加载失败
            this.error = true
            reject(error)
          })
      })
    },
    onChangeCategory(index, category) {
      this.currentCategory = category
      this.loadIssueList()
    },
    onChange(event) {
      this.activeName = event
    },
    handleRefresh() {
      this.refreshing = true
      this.loadIssueList()
        .then()
        .finally(() => {
          this.refreshing = false
          Toast.success('刷新成功')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.faq-list-container {
  background-color: #eee;
  min-height: 100vh;
}
</style>
